import { useFpCampaignCartService } from '@cart-services/hooks/useFpCampaignCartService'
import { type PartialCartItem } from '@cart-services/types'
import { CollapseProductItem, type CollapseProductItemProps } from '@cart-ui/CollapseProductItem/CollapseProductItem'
import { sendFastpassAddToCartEvent } from '@dni-analysis'
import { generateItemVariant } from '@dni-analysis/events/utils'
import { DELIVERY_CLASS } from '@hooks-api/types/dataModel/shipping'
import { type SnackbarVariantsProps } from '@pets-ui/Snackbar/SnackbarVariants'
import { useSnackbar } from '@pets-ui/Snackbar/useSnackbar'
import { useProductCatalog } from '../ProductCatalogProvider/useProductCatalog'
export const CampaignCollapseProductItem = (props: CollapseProductItemProps) => {
  const { id, variation, currentQty } = props
  const { currency, campaignId, projectCode, campaignCode } = useProductCatalog()
  const { upsertCartItem, isCartItemAddForbidden, items } = useFpCampaignCartService(campaignId)
  const { openSnackbar } = useSnackbar<SnackbarVariantsProps>()
  const handleQuantityChange = (quantity?: number) => {
    if (quantity === undefined) return

    const item: PartialCartItem = {
      ...variation,
      cartItemId: variation.variation_id,
      quantity,
    }
    const currentItem = items.find(item => item.cartItemId === variation.variation_id)
    const isAddedToCart = (currentItem?.quantity || 0) < quantity
    if (isAddedToCart) {
      sendFastpassAddToCartEvent({
        campaign_code: campaignCode,
        currency,
        value: variation.sale_price,
        items: [{
          currency,
          item_name: variation.name,
          item_id: String(variation.variation_id ?? ''),
          price: variation.sale_price,
          quantity,
          item_brand: projectCode,
          item_variant: generateItemVariant({
            productName: variation.name,
            attributes: variation.attributes,
          }),
        }],
      })
    }

    const isForbidden = isCartItemAddForbidden({ itemWantToAdd: item })
    if (isForbidden && isForbidden.mixedDeliveryClassIsForbidden) {
      if (variation.delivery_class === DELIVERY_CLASS.FROZEN) {
        openSnackbar({
          severity: 'error',
          message: '冷凍商品需要單獨結帳，購物車現在還有其他商品喔',
          showProgressBar: true,
          autoHideDuration: 3000,
        })
      }
      else if (variation.delivery_class === DELIVERY_CLASS.NORMAL) {
        openSnackbar({
          severity: 'error',
          message: '常溫商品需要單獨結帳，購物車現在還有其他商品喔',
          showProgressBar: true,
          autoHideDuration: 3000,
        })
      }
    }
    else {
      upsertCartItem(item)
    }
  }

  return (
    <CollapseProductItem
      id={id}
      variation={variation}
      currentQty={currentQty}
      onQuantityChange={handleQuantityChange}
    />
  )
}
